import { SIGNAL_COLORS } from "../lib/signal"

export function Section3Lattice() {
  return (
    <div className="copy-block narrow guarded-copy" data-motion="reveal">
      <p className="eyebrow mono">CROSS-SECTIONAL READ</p>
      <h2>Every name, classified.</h2>
      <p>
        Ninety-six cells arrange region, sector, and instrument type into a single
        signal lattice. Leader, constructive, neutral, laggard, and stress labels stay
        visible instead of hiding in a score.
      </p>
      <div className="legend mono">
        {Object.entries(SIGNAL_COLORS).map(([sig, color]) => (
          <span key={sig} style={{ borderColor: color }}>{sig}</span>
        ))}
      </div>
    </div>
  )
}
